import React from 'react'

const MessageCenterContext = React.createContext({
  isOpen: false,
})

export default MessageCenterContext
